// Module utilitaire : empêche la saisie de caractères invalides dans les champs input[type="number"]
let numericInputGuard = (() => {
  const CONFIG = {
    blockedKeys: new Set([".", ",", "e", "E", "-", "+"]),
    eventOptions: { passive: false, capture: true }
  };

  const handleKeydown = (e) => {
    if (e.target.type === "number" && CONFIG.blockedKeys.has(e.key)) {
      e.preventDefault();
    }
  };

  // Utilise la délégation d'événements pour une meilleure performance
  // (un seul gestionnaire d'événement au lieu d'un par input)
  const init = () => {
    document.addEventListener("keydown", handleKeydown, CONFIG.eventOptions);
  };

  return {
    init
  };
})();

window.numericInputGuard = numericInputGuard;
export default numericInputGuard;
